module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAAAJ1JREFUWEftlsEJwzAQBKUKXIJTikuxK3M6i9yBO5BPhoRAnvM5whju4cfCMHeIrb33pZSyxzxiMn0tYLYagK+EcG9RbQCe8TdlUvfFcgzAseJnzJwM8gietSaD+sERkG5IgxqkBmjeG9QgNUDz3uD/G7RRsx3bqIk/GzWx98n6UFONGtQgNUDz3qAGqQGa9waxQRs1U2ijJv7uRn0BFLg8wqCwUN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_menu.png
// module id = c1tM
// module chunks = 38